import { runtimeConfig } from "../runtime-config";

export class ServiceBase {
  protected baseUrl = runtimeConfig.ahbExpressionBaseUrl;
}
